const teamMembers = [
  {
    name: "Ahmed Hassan",
    role: "CEO & Founder",
    initials: "AH",
    color: "bg-blue-100 text-blue-700",
  },
  {
    name: "Sara Khan",
    role: "Lead Developer",
    initials: "SK",
    color: "bg-purple-100 text-purple-700",
  },
  {
    name: "Ali Raza",
    role: "UI/UX Designer",
    initials: "AR",
    color: "bg-green-100 text-green-700",
  },
  {
    name: "Fatima Malik",
    role: "Cloud Architect",
    initials: "FM",
    color: "bg-pink-100 text-pink-700",
  },
];

const values = [
  { icon: "🎯", title: "Client First", desc: "Your success is our top priority." },
  { icon: "⚡", title: "Fast Delivery", desc: "We ship on time, every time." },
  { icon: "🔒", title: "Secure & Reliable", desc: "Enterprise-grade security built-in." },
  { icon: "🤝", title: "Long-term Partnership", desc: "We grow with your business." },
];

export default function About() {
  return (
    <section id="about" className="py-28 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-blue-600 font-semibold text-sm uppercase tracking-wide">
            Who We Are
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mt-2 mb-4">
            About Nexora Ventures
          </h2>
          <p className="text-slate-500 max-w-xl mx-auto text-lg leading-relaxed">
            A passionate team of engineers and designers building digital products that make a difference for growing businesses.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-start mb-20">
          <div className="space-y-6 animate-fade-in">
            <div className="rounded-[2rem] border border-slate-200 bg-slate-50 p-8 shadow-sm">
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Our Story</h3>
              <p className="text-slate-600 leading-relaxed mb-4">
                Founded in 2019, Nexora Ventures began with a simple vision: to make enterprise-level technology accessible to businesses of all sizes. Starting as a small team of developers, we now deliver full-service digital solutions across multiple industries.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                We partner with startups, growing businesses, and enterprises to transform ideas into scalable web apps and secure cloud platforms. Our journey is defined by innovation, quality, and measurable impact.
              </p>
              <p className="text-slate-600 leading-relaxed">
                Today, with 200+ successful projects and a growing global client base, we continue to push boundaries and deliver solutions that empower brands to grow faster and smarter.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-4">
              {[
                { v: "200+", l: "Projects" },
                { v: "50+", l: "Clients" },
                { v: "5 yrs", l: "Experience" },
              ].map((s) => (
                <div key={s.l} className="rounded-[1.5rem] bg-blue-50 p-5 text-center shadow-sm">
                  <p className="text-2xl font-extrabold text-blue-600">{s.v}</p>
                  <p className="text-sm text-slate-500 mt-1">{s.l}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-6 animate-fade-in animate-fade-in-delay-100">
            <div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Our Values</h3>
              <div className="grid grid-cols-2 gap-4">
                {values.map((val) => (
                  <div
                    key={val.title}
                    className="rounded-3xl border border-slate-200 bg-slate-50 p-5 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
                  >
                    <span className="text-3xl mb-3 block">{val.icon}</span>
                    <p className="font-semibold text-slate-900 text-sm">{val.title}</p>
                    <p className="text-sm text-slate-500 mt-2">{val.desc}</p>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-slate-900 text-center mb-8">Meet the Team</h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                {teamMembers.map((member) => (
                  <div
                    key={member.name}
                    className="rounded-[1.75rem] border border-slate-200 bg-slate-50 p-6 text-center transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl"
                  >
                    <div className={`${member.color} mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-3xl text-xl font-bold`}>
                      {member.initials}
                    </div>
                    <p className="font-semibold text-slate-900 text-sm">{member.name}</p>
                    <p className="text-xs text-slate-500 mt-1">{member.role}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
